import { useCallback, useState } from "react";
import debounce from "lodash/debounce";
import { useDispatch } from "react-redux";

import actions from "../../Store/actions";

const DEBOUNCE_DELAY = 400;
export default () => {
    const dispatch = useDispatch();

    const useDebounceSearch = useCallback(
        debounce((value: string) => {
            if (value.length >= 3) {
                dispatch(
                    actions.search.create.searchRequest(value.toLowerCase())
                );
            } else if (value.length === 0) {
                dispatch(actions.search.create.clearResults());
            }
        }, DEBOUNCE_DELAY),
        []
    );
    return useDebounceSearch;
};
